import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from "../config/analyticsTrack";
import "./GHT.css"
import Logo from './assets/logo.png'
import res1 from './assets/resources/res1.png'
import res2 from './assets/resources/res2.png'
import resources from './assets/resources/resources.pdf'
import slide1 from './assets/resources/slide/1.png'
import slide2 from './assets/resources/slide/2.png'
import slide3 from './assets/resources/slide/3.png'
import slide4 from './assets/resources/slide/4.png'
import slide5 from './assets/resources/slide/5.png'
import slide6 from './assets/resources/slide/6.png'
import slide7 from './assets/resources/slide/7.png'
import slide8 from './assets/resources/slide/8.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Header from './components/Header';
import Footer from './Footer';
import Slider from '../components/Slider';
import Modal from '../components/Modal';

export default function GhtResources(props) {
    const [showMenu, setShowMenu] = useState(false);
    const [active, setActive] = useState(null);

    useEffect(() => {
        analyticsUserTrack("GHT - GHT Resources", "Landing");
        window.scrollTo(0, 0);
    }, [])

    function viewModalData() {
        let returnText = ""
        switch (active) {
            case "1":
                returnText = <Slider slider={
                    [
                        <img src={slide1} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide2} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide3} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide4} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide5} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide6} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide7} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                        <img src={slide8} className='carosal_img' style={{ maxHeight: "80vh" }} />,
                    ]
                } />
                break;
            case "2":
                returnText = <React.Fragment>
                    <object data={resources} type="application/pdf" width="100%" height={window.innerHeight - 200}></object>
                </React.Fragment>
                break;
            default:
                returnText = ""
                break;
        }
        return returnText

    }

    return <div className='version-2 GHT nairobi-june'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/GHT"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                <Header page="social-impact" />
            </div>
        </div>

        <div className='container py-5'>
            <div className='d-flex justify-content-center heading-text text-center' >
                <div className={`montserrat-font-family fw-bold`}>GHT Resources</div>
            </div>
            <div className='d-flex'>
                <div className='flex-1 cursor-pointer' onClick={() => {
                    setActive("2")
                    analyticsUserTrack("GHT - GHT Resources", "Clicked - PDF");
                }}>
                    <img className='img-fluid' src={res1} />
                </div>
                <div className='flex-1 mx-5 cursor-pointer' onClick={() => {
                    setActive("1")
                    analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                }}>
                    <img className='img-fluid' src={res2} />
                </div>
            </div>
        </div>
        {
            active && <Modal
                visible={active ? true : false}
                closeModal={() => {
                    setActive("")
                }}
                heading={""}
                size={"modal-xl"}
                body={<React.Fragment>
                    {viewModalData()}
                </React.Fragment>
                }
                footer={<button className='btn btn-sm btn-primary' style={{ cursor: "pointer" }} onClick={() => {
                    setActive("")
                }}>Close</button>}
            />
        }
        <Footer />
    </div>
}
